var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('h2',[_vm._v("Congratulation")]),_c('p',[_vm._v("Payment Sucessfull")]),_c('p',[_vm._v("ORDER ID: "+_vm._s(_vm.order_id))])])}
var staticRenderFns = []

export { render, staticRenderFns }